export default __webpack_public_path__ + "static/media/ranes12.245816a6.jpg";